export const ctm = {
    data: {
        vertical: {
            car: {
                media: {
                    header_logo_image_url: '/evt/assets/brand/ctm/images/ctm-logo-inline.svg',
                    header_logo_image_url_small: '/evt/assets/brand/ctm/images/ctm-logo-stacked.svg',
                    error_page_quote_something_went_wrong_image_url: '/evt/assets/brand/ctm/sergei-error.png',
                    quote_expired_screen_image_url: '/evt/assets/brand/ctm/images/alexander.png',
                    rego_lookup_loading_screen_hero_image_url: '/evt/assets/brand/ctm/images/alexander_half.png',
                    welcome_back_hero_image_url: '/evt/assets/brand/ctm/images/sergei_trumpet.png',
                    price_confidence_banner_mobile_url: null,
                    price_confidence_banner_tablet_url: null,
                    price_confidence_banner_desktop_url: null
                },
                links: {
                    application_details_opt_in_checkbox_privacy_policy_url: 'https://secure.comparethemarket.com.au/static/legal/privacy_collection_notice_car.pdf',
                    application_details_opt_in_checkbox_financial_services_guide_url: 'https://secure.comparethemarket.com.au/static/legal/FSG.pdf',
                    application_details_opt_in_checkbox_terms_of_use_url: 'https://secure.comparethemarket.com.au/static/legal/website_terms_of_use.pdf',
                    footer_disclaimer_how_comparison_works_url: 'https://www.comparethemarket.com.au/car-insurance/disclosures/',
                    footer_disclaimer_financial_services_guide_url: 'https://secure.comparethemarket.com.au/static/legal/FSG.pdf',
                    footer_disclaimer_terms_of_use_url: null,
                    footer_copyright_banner_privacy_policy_url: 'https://secure.comparethemarket.com.au/static/legal/privacy_policy.pdf',
                    footer_copyright_banner_terms_of_use_url: 'https://secure.comparethemarket.com.au/static/legal/website_terms_of_use.pdf',
                    header_logo_image_link: 'https://www.comparethemarket.com.au'
                },
                copy: {
                    footer_copyright_banner_brand_name: 'Compare the Market',
                    application_details_opt_in_checkbox_brand_name: 'Compare the Market',
                    rego_lookup_licence_plate_placeholder: '123CTM',
                    rego_lookup_default_licence_plate_state_label: 'Compare the market',
                    rego_lookup_welcome_message: "Welcome to Compare the Market. We're here to help you find a great deal on car insurance."
                }
            },
            home: {
                media: {
                    header_logo_image_url: '/evt/assets/brand/ctm/images/ctm-logo-inline.svg',
                    header_logo_image_url_small: '/evt/assets/brand/ctm/images/ctm-logo-stacked.svg',
                    error_page_quote_something_went_wrong_image_url: '/evt/assets/brand/ctm/sergei-error.png',
                    shielded_thank_you_hero_image_url: '/evt/assets/brand/ctm/images/alexander_sergei.png',
                    welcome_back_hero_image_url: '/evt/assets/brand/ctm/images/sergei_trumpet.png',
                    price_confidence_banner_mobile_url: '/evt/assets/brand/ctm/images/price-confidence-banner-mobile.png',
                    price_confidence_banner_tablet_url: '/evt/assets/brand/ctm/images/price-confidence-banner-tablet.png',
                    price_confidence_banner_desktop_url: '/evt/assets/brand/ctm/images/price-confidence-banner-desktop.png'
                },
                links: {
                    application_details_opt_in_checkbox_privacy_policy_url: 'https://secure.comparethemarket.com.au/static/legal/privacy_collection_notice_home_contents.pdf',
                    application_details_opt_in_checkbox_financial_services_guide_url: 'https://secure.comparethemarket.com.au/static/legal/FSG.pdf',
                    application_details_opt_in_checkbox_terms_of_use_url: 'https://secure.comparethemarket.com.au/static/legal/website_terms_of_use.pdf',
                    footer_disclaimer_how_comparison_works_url: 'https://www.comparethemarket.com.au/home-contents-insurance/disclosures/',
                    footer_disclaimer_financial_services_guide_url: 'https://secure.comparethemarket.com.au/static/legal/FSG.pdf',
                    footer_disclaimer_terms_of_use_url: null,
                    footer_copyright_banner_privacy_policy_url: 'https://secure.comparethemarket.com.au/static/legal/privacy_policy.pdf',
                    footer_copyright_banner_terms_of_use_url: 'https://secure.comparethemarket.com.au/static/legal/website_terms_of_use.pdf',
                    header_logo_image_link: 'https://www.comparethemarket.com.au'
                },
                copy: {
                    footer_copyright_banner_brand_name: 'Compare the Market',
                    application_details_opt_in_checkbox_brand_name: 'Compare the Market'
                }
            },
            travel: {
                links: {
                    footer_copyright_banner_privacy_policy_url: 'https://secure.comparethemarket.com.au/static/legal/privacy_policy.pdf',
                    footer_copyright_banner_terms_of_use_url: 'https://secure.comparethemarket.com.au/static/legal/website_terms_of_use.pdf',
                    footer_disclaimer_how_comparison_works_url: 'https://www.comparethemarket.com.au/travel-insurance/disclosures/',
                    footer_disclaimer_financial_services_guide_url: 'https://secure.comparethemarket.com.au/static/legal/FSG.pdf',
                    footer_disclaimer_terms_of_use_url: 'https://secure.comparethemarket.com.au/static/legal/website_terms_of_use.pdf',
                    application_details_opt_in_checkbox_privacy_policy_url: 'https://secure.comparethemarket.com.au/static/legal/privacy_policy.pdf',
                    application_details_opt_in_checkbox_financial_services_guide_url: 'https://secure.comparethemarket.com.au/static/legal/FSG.pdf',
                    application_details_opt_in_checkbox_terms_of_use_url: 'https://secure.comparethemarket.com.au/static/legal/website_terms_of_use.pdf',
                    header_logo_image_link: 'https://www.comparethemarket.com.au'
                },
                media: {
                    destinations_page_image_url: null,
                    policy_type_page_image_url: null,
                    cover_levels_page_image_url: null,
                    single_trip_dates_page_image_url: null,
                    annual_cover_details_page_image_url: null,
                    travellers_ages_page_image_url: null,
                    extra_cover_page_image_url: null,
                    contact_details_page_image_url: null,
                    results_loading_page_image_url: null,
                    whoops_error_modal_image_url: null,
                    handover_page_image_url: null,
                    no_results_image_url: null,
                    extra_cover_snow_image_url: null,
                    extra_cover_cruise_image_url: null
                },
                copy: {}
            }
        },
        design_system: {
            everest: {
                brand_primary: '#001464',
                brand_secondary: '#0F58AB',
                brand_base: '#2B2B31',
                feature_1: '#001464',
                feature_2: '#F5D155',
                feature_3: '#EF5123',
                feature_4: '#ED4651',
                brand_primary_120: '#001443',
                brand_primary_80: '#0F58AB',
                brand_primary_60: '#1E7BD9',
                brand_primary_30: '#B4D4F8',
                brand_primary_10: '#D0E4FB',
                brand_secondary_120: '#0E4C96',
                brand_secondary_80: '#1E7BD9',
                brand_secondary_60: '#B4D4F8',
                brand_secondary_30: '#D0E4FB',
                brand_secondary_10: '#F4F8FD',
                brand_base_120: '#000000',
                brand_base_80: '#717486',
                brand_base_60: '#8F92A1',
                brand_base_20: '#E9E9EC',
                brand_base_10: '#FCFCFD',
                brand_base_0: '#ffffff',
                feature_1_120: '#001443',
                feature_1_80: '#ADA8A6',
                feature_1_60: '#EAE7DD',
                feature_1_30: '#D0E4FB',
                feature_1_10: '#F8F7F4',
                feature_2_120: '#DEB90F',
                feature_2_80: '#F8E48F',
                feature_2_60: '#FCF2C9',
                feature_2_30: '#FEFBEC',
                feature_2_10: '#FEFBEC',
                feature_3_120: '#EB2500',
                feature_3_80: '#F2744F',
                feature_3_60: '#F5977B',
                feature_3_30: '#FACBBD',
                feature_3_10: '#FDEEE9',
                feature_4_120: '#B91E28',
                feature_4_80: '#F7727B',
                feature_4_60: '#ED9B96',
                feature_4_30: '#FBA6AB',
                feature_4_10: '#FEF2F3',
                body_color: '#001443',
                body_background_color: '#FAFAFA',
                validation_error_color: '#ED4651',
                validation_error_bg_color: '#FEF2F3',
                validation_success_color: '#0F58AB',
                form_label_color: '#001464',
                color_border_default: '#E9E9EC',
                color_border_input_default: '#717486',
                modal_overlay_dark: 'rgba(0, 0, 0, 0.7)',
                modal_overlay_light: 'rgba(255, 255, 255, 0.3)',
                family_base: 'Plus Jakarta Sans, Helvetica, Arial, sans-serif',
                family_heading: 'Plus Jakarta Sans, Helvetica, Arial, sans-serif',
                medicare_green: '#b9f79e',
                medicare_blue: '#d4eef5',
                medicare_yellow: '#f7e97b',
                energy_secondary_button: '#0ec228',
                energy_secondary_button_120: '#0ea324',
                energy_primary_button: '#0ec228',
                energy_primary_button_120: '#0ea324',
                result_hint_yellow: '#f0e599',
                energy_feature_blue: '#001443',
                energy_label_highlight_blue: '#e7f2fd',
                a_link: '#0f58AB',
                input_border_radius: '5px',
                next_button_border_radius: '99999px',
                handover_button_border_radius: '99999px',
                progress_bar_inactive: '#E9E9EC',
                progress_bar_active: '#0f58AB',
                registration_number_border_color: '#0f58AB',
                rego_lookup_loading_screen_background_color: '#001464',
                radio_input_color: '#0F58AB',
                radio_icon_color: '#0F58AB',
                call_options_icon_inactive: '#0F58AB',
                call_options_icon_active: '#0F58AB',
                background_theme_color: '#0F58AB',
                font_40: '4rem',
                font_32: '3.2rem',
                font_24: '2.4rem',
                font_20: '2rem',
                font_18: '1.8rem',
                font_16: '1.4rem',
                font_14: '1.3rem',
                font_12: '1.1rem',
                font_10: '.9rem'
            }
        }
    }
};
